<h3 class="mat-dialog-title">Quick Import Contacts</h3>
<div class="mat-dialog-content">

  <div *ngIf="!fileProcessed" class="">
    <p>
      Enter/Paste a list of contacts here. (Max*: 5000)
      <br>
      <small>* Upload a file instead, if you want to exceed the limit.</small>
    </p>

    <br>

    <app-select-field *ngIf="groups.length > 0" name="Group" [isObject]="true" [required]="true" [noEmptyValue]="true"
     [options]="groups" objectNameField="name" [(value)]="selectedGroup" (valueChange)="setGroupForContacts()" helpText="Group to save the contacts to"></app-select-field>

    <br>
    <app-select-field name="Delimiter" [options]="txtDelimiters" [required]="true" [noEmptyValue]="true" [(value)]="selectedTxtDelimiter" helpText="What character separates each of the contacts?"></app-select-field>

    <br>
    <label>Contacts</label>
    <textarea class="form-control border-input" name="importList" rows="6" maxlength="70000" placeholder="Paste the contacts here"
      [(ngModel)]="tempImportList"></textarea>
    <span class="help-block animated fadeIn" [class.hidden]="!importRecipientError">
      <strong class="text-danger">One or more contacts is invalid</strong>
    </span>
  </div>

  <div *ngIf="fileProcessed">
    <p>Confirm the detected contacts and then click on IMPORT to finalize your upload.
      <br> <b>Total: {{ contacts?.length || 0 }} contacts</b>
    </p>
    <hr>
    <app-contacts-preview [contacts]="contacts" (onRemoveContact)="removeRecipient($event)"></app-contacts-preview>
    <hr>
  </div>

</div>

<div class="mat-dialog-actions pull-right">
  <button type="button" class="btn btn-default" tabindex="-1" (click)="dialogRef.close()">Cancel</button>
  &nbsp; &nbsp;
  <!-- <button type="button" class="btn btn-primary" tabindex="1" (click)="onImport()">Import</button> -->
  <button *ngIf="!fileProcessed" type="button" class="btn btn-primary" tabindex="1" (click)="onCheckImportContacts()">Next</button>
  <button *ngIf="fileProcessed" type="button" class="btn btn-primary" tabindex="1" (click)="onImport()" [disabled]="!fileProcessed">Import</button>
</div>
